<template>
    <div class="flex w-full h-full">
        <div class="p-36 basis-1/2 flex flex-col gap-36">
            <h1 class="text-30 font-black uppercase"><WFTranslate k="bustimes"></WFTranslate></h1>
            <div class="w-full">
                <table class="text-16 w-full">
                    <thead class="bg-secondary font-black">
                        <tr >
                            <td v-for="head in heads" :key="head" class="p-12">{{ head }}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(stop, index) in times" :key="index" class="even:bg-neutral2 odd:bg-white">
                            <td v-for="(time, index2) in stop" :key="index2" class="p-12">{{ time }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="basis-1/2">
            <img class="w-full h-full object-cover" src="../assets/Map.png"/>
        </div>
    </div>
</template>

<script>

import dayjs from 'dayjs';
var customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

export default {
    data() {
        return {
            times: [],
            heads: [],
        };
    },
    mounted() {
        let project = this.$wayfinder.options.project;

        fetch("https://do.3dwayfinder.com/api/r/bustimes/et/" + project, {
            headers: {
                Authorization: `Bearer ${this.$DO_TOKEN}`,
            }
        }).then(resp1 => resp1.json()).then((times) => {
            if(times && times.data && Array.isArray(times.data)){
                let stops = times.data;
                this.heads = stops.map(t => t.name)
                this.times = [];
                let time;
                for(let s = 0; s < stops.length; s++) {
                    for(let t = 0; t < stops[s].times.length; t++) {
                        if (!this.times[t]) {
                            this.times[t] = new Array(this.heads.length);
                        }
                        if (stops[s] && stops[s].times && stops[s].times[t]) {
                            time = dayjs(stops[s].times[t].arrivalTime, "HH:mm:ss");
                            this.times[t][s] = time.format("HH:mm");
                        }
                    }
                }
            }   
        });
    }
}

</script>